// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".site-container[data-v-df0bb0d4]{display:flex;position:relative;width:100%;justify-content:center;text-align:left}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
